import {createRoot} from "react-dom/client";
import React, {useEffect, useState} from "react";
import {Configure, InstantSearch, useHits} from "react-instantsearch-hooks-web";
import Map, {FullscreenControl, NavigationControl, ScaleControl} from "react-map-gl";
import Announce from "./Map/Markers/Announce";
import AppPreloader from "./Elements/Preloaders/AppPreloader";
import FilterContext from "./Context/FilterContext";
import useProps from "./Hooks/useProps";
import 'mapbox-gl/dist/mapbox-gl.css';

const CustomMap = props => {
    const {lat, lng, token, zoom} = props
    const { hits } = useHits()
    const [loading, setLoading] = useState(true)

    return (
        <>
            <Map
                mapStyle="mapbox://styles/mapbox/streets-v11"
                mapboxAccessToken={token}
                initialViewState={{
                    longitude: lng,
                    latitude: lat,
                    zoom: zoom
                }}
                onStyleData={() => setTimeout(() => setLoading(false), 500)}
            >

                <FullscreenControl />
                <ScaleControl position='bottom-right'/>
                <NavigationControl position='bottom-left'/>

                <>
                    {
                        hits
                            .filter(hit => hit._geoloc !== undefined)
                            .map(hit => <Announce key={'announce-' + hit.objectID} hit={hit} />)
                    }
                </>
            </Map>
            {loading ? <AppPreloader style={{zIndex: 50}} /> : null}
        </>
    )
}

const SeoList = props => {
    const { address, algolia, filters, mapbox, options } = props

    return (
        <InstantSearch searchClient={algolia.client} indexName={algolia.prefix + 'announces'}>
            <Configure
                filters={filters.announceIds}
                hitsPerPage={80}
            />
            <FilterContext.Provider value={{}}>
                <CustomMap {...{...address, ...options, ...mapbox}} />
            </FilterContext.Provider>
        </InstantSearch>
    )
}

function render() {
    const el = document.getElementById('seo-list-search')

    const root = createRoot(el)

    const props = useProps({
        container: el
    })

    root.render(
        <SeoList {...props} />
    );
}

document.addEventListener('DOMContentLoaded', render)